var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 40,
    width: 40,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 21.958 11.458 30.5q-.416.417-.979.417-.562 0-.979-.417-.417-.417-.417-.979 0-.563.417-.979L18.042 20 9.5 11.458q-.417-.416-.417-.979 0-.562.417-.979.417-.417.979-.417.563 0 .979.417L20 18.042 28.542 9.5q.416-.417.979-.417.562 0 .979.417.417.417.417.979 0 .563-.417.979L21.958 20l8.542 8.542q.417.416.417.979 0 .562-.417.979-.417.417-.979.417-.563 0-.979-.417Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/CloseIcon.c92cfb52171a1fdb49ad51424c88c8de.svg";
export { ForwardRef as ReactComponent };